<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelCheck()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Check Ward</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <items [document]="documentTemp"></items>
  <
</ion-content>
